<template>
  <span
    class="icon ribbon"
  >{{ text }}</span>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;
</style>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>
